import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for internal navigation
import '../assets/css/Card.css'; // For styling

const BlogCard = ({ title, image, description, link }) => {
  return (
    <Link to={link} className="card">
      <div className="card-image-container">
        <img src={image} alt={title} className="card-image" />
      </div>
      <div className="card-content">
        <h2 className="card-title">{title}</h2>
        <p className="card-description">{description}</p>
        <div className="card-button">
          Read More &nbsp; <i className="bi bi-arrow-right-short"></i>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;